import { useTranslation } from 'react-i18next'
import FormSelect from 'components/form/FormSelect'
import PropTypes from 'prop-types'
import { Globe } from 'react-feather'

const LanguagePicker = ({ showLabel = true }) => {
  LanguagePicker.propTypes = {
    showLabel: PropTypes.bool,
  }

  const options = [
    { value: 'es', label: 'Castellano' },
    { value: 'it', label: 'Italiano' },
    { value: 'en', label: 'English' },
    { value: 'ca', label: 'Català' },
  ]

  const { t, i18n } = useTranslation('common')

  const onChange = (option) => {
    const { value } = option
    i18n.changeLanguage(value)
    localStorage.setItem('lang', value)
  }

  return (
    <div className="d-flex gap-3 mx-2 align-items-center">
      {showLabel ? (
        <div className="d-flex gap-2 mt-2">
          <div>
            <Globe />
          </div>
          <div className="text-bottom">{t('language')}</div>
        </div>
      ) : null}

      <div className="w-100">
        <FormSelect
          options={options}
          onChange={onChange}
          name="lang"
          defaultValue={options.find((op) => op.value === i18n.language)}
        />
      </div>
    </div>
  )
}

export default LanguagePicker
